import type { ContactResponse } from "pages/media/types";

/**
 * The narrator is picked as an avatar (a contact), but every add-on's API field
 * is that avatar's VOICE — so this is the accessor the option lists and the
 * draft seed both bind to.
 */
export const voiceProfileId = (contact: ContactResponse) =>
  contact.presenter.voice_profile.id;

/**
 * Contacts whose voice can speak the emotion tags a podcast script carries.
 * The podcast is the only add-on that requires this: its generation fails
 * outright on a voice that can't, whereas AudioDoc opts in per-project
 * (`with_emotions`, default false) and may use any voice.
 *
 * The capability lives in the voice profile's free-form `tags`, whose values
 * are STRINGS — so `"false"` is truthy and has to be compared explicitly.
 */
export const emotionCapableContacts = (contacts: ContactResponse[]) =>
  contacts.filter(
    (contact) =>
      contact.presenter.voice_profile.tags?.supports_emotions === "true"
  );
